import {Injectable} from '@angular/core';
import {ApiService} from '../../core/services/api.service';

@Injectable()
export class OptimaxGlobaleUserService {
    constructor(
        private apiService: ApiService
    ) {}

    getGlobaleOptimaxToken(callback: any = null) {
        const token = localStorage.getItem('global_optimaxToken');

        if (!token || token === '') {
            this.apiService.get('optimax/authentication/getGlobalUserOptimax').subscribe(response => {
                if (!response.data || response.status !== 200)
                    return null;
                localStorage.setItem('global_optimaxToken', response.data['rox_optimax_token']);
                if (callback)
                    callback(response.data['rox_optimax_token']);
                return (response.data['rox_optimax_token']);
            });
        }
        if (callback)
            callback(token);
        return (token);
    }

    getGlobaleOptimaxApiType() {
        return 'ms'; //TODO not implemented for google
    }

    removeGlobaleOptimaxUser() {
        const token = this.getGlobaleOptimaxToken();

        if (!token)
            return false;

        this.apiService.post('optimax/authentication/removeGlobalUserOptimax', {token: token}).subscribe(response => {
            if (response.status !== 200)
                return false;
            localStorage.removeItem('global_optimaxUser');
            localStorage.removeItem('global_optimaxToken');
            localStorage.removeItem('global_optimaxHasApi');
            localStorage.removeItem('global_optimaxApiType');
        });
        return true;
    }
}
